var map = {
	"./404.svg": 33530,
	"./5g_blue.svg": 75385,
	"./admin_sidebar_bg.svg": 33729,
	"./auth_checking.svg": 56452,
	"./auth_never.svg": 72651,
	"./auth_success.svg": 3910,
	"./bug.svg": 37130,
	"./chart.svg": 38545,
	"./chatbot.svg": 54892,
	"./clipboard.svg": 36637,
	"./close.svg": 93318,
	"./code.svg": 37260,
	"./component.svg": 2406,
	"./contact.svg": 48509,
	"./customer_sidebar_bg.svg": 49976,
	"./dashboard.svg": 58749,
	"./documentation.svg": 59607,
	"./drag.svg": 60224,
	"./edit.svg": 48352,
	"./education.svg": 23085,
	"./email.svg": 51533,
	"./example.svg": 49892,
	"./excel.svg": 99139,
	"./exit-fullscreen.svg": 80871,
	"./eye-open.svg": 14301,
	"./eye.svg": 34986,
	"./form.svg": 74062,
	"./fullscreen.svg": 16286,
	"./guide.svg": 55860,
	"./home.svg": 49429,
	"./home_admininfo_icon.svg": 85548,
	"./home_userinfo_icon.svg": 30923,
	"./icon.svg": 69789,
	"./info.svg": 65051,
	"./international.svg": 13906,
	"./keyboard.svg": 13763,
	"./language.svg": 59424,
	"./limit.svg": 58338,
	"./link.svg": 14121,
	"./list.svg": 72672,
	"./lock.svg": 96648,
	"./login_user_bg.svg": 2260,
	"./material.svg": 16986,
	"./message.svg": 30860,
	"./money.svg": 11116,
	"./msg.svg": 22217,
	"./nested.svg": 91476,
	"./password.svg": 46408,
	"./pdf.svg": 26500,
	"./pencil_edit.svg": 79303,
	"./people.svg": 22011,
	"./peoples.svg": 95765,
	"./phone.svg": 65522,
	"./qq.svg": 56869,
	"./search.svg": 42042,
	"./setting.svg": 81016,
	"./shopping.svg": 68764,
	"./size.svg": 40985,
	"./skill.svg": 78673,
	"./star.svg": 68019,
	"./tab.svg": 90817,
	"./table.svg": 3797,
	"./template.svg": 37609,
	"./theme.svg": 60987,
	"./tree-table.svg": 38509,
	"./tree.svg": 40964,
	"./user.svg": 30042,
	"./user_login_content_bg.svg": 23638,
	"./wechat.svg": 70267,
	"./zip.svg": 47276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;